import { render, staticRenderFns } from "./tougubaogao.vue?vue&type=template&id=1c9f138a&scoped=true"
import script from "./tougubaogao.vue?vue&type=script&lang=js"
export * from "./tougubaogao.vue?vue&type=script&lang=js"
import style0 from "./tougubaogao.vue?vue&type=style&index=0&id=1c9f138a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9f138a",
  null
  
)

export default component.exports